import React from "react";
import styled from "styled-components";

/**
 * 表の末尾に置く「ファイルを追加する行」。
 *
 * クリックでファイル選択ダイアログを開く入口で、表の外にアップローダーを
 * 置かずに済ませるためのもの（表全体をドロップゾーンにする実装と対で使う）。
 * 行として自然に見えるよう枠・背景は持たず、ホバーで青くしてクリックできる
 * ことを示す。
 *
 * `<td colSpan>` の中に置いて全幅で使う想定。
 */
export interface TableAddFileRowProps {
  /** クリック時にファイル選択ダイアログを開くハンドラ。 */
  onClick: () => void;
  /** 行に出すラベル。何が登録されるかまで書くこと。 */
  label: string;
  /** アップロード中など、一時的に押せなくする。 */
  disabled?: boolean;
  ariaLabel?: string;
}

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 4px 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--soremo-light-gray);
  text-align: left;
  transition: color 0.2s;

  .material-symbols-rounded {
    font-size: 18px;
    color: inherit;
  }

  &:hover:not(:disabled) {
    color: var(--soremo-blue);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const TableAddFileRow: React.FC<TableAddFileRowProps> = ({
  onClick,
  label,
  disabled = false,
  ariaLabel,
}) => (
  <Button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel ?? label}
  >
    <span className="material-symbols-rounded">add</span>
    <span className="bodytext-13">{label}</span>
  </Button>
);

export default TableAddFileRow;
